import React from "react";

import { createStructuredSelector } from "reselect";
import {
  selectSaudhaScreen,
  selectSelectedCrop,
} from "../../redux/common/common.selectors";
import { connect } from "react-redux";
import OpenAuctionPage from "./open-auction.page";
import SaudhaPage from "../saudha/saudha.page";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";

const OpenAuctionLanding: React.FC = (props: any) => {
  // const { isSaudhaActive } = props;
  const { path } = useRouteMatch();
  //  isSaudhaActive ? <SaudhaPage /> : <OpenAuctionPage {...props} />;
  return (
    <Switch>
      <Route exact path={`${path}`}>
        <OpenAuctionPage {...props} />
      </Route>
      <Route exact path={`${path}/saudadetails`}>
        <SaudhaPage />
      </Route>
      <Redirect to={`${path}`} />
    </Switch>
  );
};

const mapStateToProps = createStructuredSelector({
  isSaudhaActive: selectSaudhaScreen,
});

export default connect(mapStateToProps)(OpenAuctionLanding);
